import { render, staticRenderFns } from "./main.vue?vue&type=template&id=5c3f2a21&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=5c3f2a21&prod&lang=less&scoped=true&"
import style1 from "./main.vue?vue&type=style&index=1&id=5c3f2a21&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f2a21",
  null
  
)

export default component.exports